import { useMemo } from 'react';
import { useLocation } from 'react-router';

import useRoutes from '../../../hooks/useRoutes';
import { useFormTokenChainContextOptional } from '../../../hooks/context/useFormTokenChainContextOptional';
import { GlobalLocationStateType } from '../../../types/types';
import { getStandaloneRootFormPath } from '../utils/getStandaloneRootFormPath';

// Inside a standalone (menu-opened) form, resolve the root form path so nested dataset-scoped
// reference routes don't highlight an unrelated leaf. Returns undefined outside a standalone form
// or when the Sidebar renders without the form-token provider.
export const useStandaloneFormPath = (): string | undefined => {
  const routes = useRoutes();
  const { pathname } = useLocation<GlobalLocationStateType>();
  const tokenChain = useFormTokenChainContextOptional();

  return useMemo(
    () =>
      tokenChain
        ? getStandaloneRootFormPath(
            tokenChain.getActualTokenFromUrl(),
            tokenChain.getToken,
            routes.relative.formAddAction()
          )
        : undefined,
    [tokenChain, pathname]
  );
};
